import { render, staticRenderFns } from "./AccountPagination.vue?vue&type=template&id=49be6848"
import script from "./AccountPagination.vue?vue&type=script&lang=ts"
export * from "./AccountPagination.vue?vue&type=script&lang=ts"
import style0 from "./AccountPagination.vue?vue&type=style&index=0&id=49be6848&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports